export default __webpack_public_path__ + "static/media/noise.3c7efafc.png";